import type { IconProps } from '@magicschool/spellbook/components/Icon';
import { Icon } from '@magicschool/spellbook/components/Icon';
import { Slot } from '@magicschool/spellbook/components/Slot';
import { cn } from '@magicschool/spellbook/lib/utils';

export const DateInputLeadingAdornmentSlot = Slot<IconProps>({
  displayName: 'DateInput.LeadingAdornment',
  renderDefault: ({ name = 'square-dashed', className, size: _, color = 'default', ...props }) => {
    return (
      <Icon
        data-spellbook-name="date-input-leading-adornment"
        name={name}
        size="sm"
        color={color}
        className={cn('m-1', className)}
        {...props}
      />
    );
  },
});
